import { render, staticRenderFns } from "./brockercharge.vue?vue&type=template&id=20043dcc"
import script from "./brockercharge.vue?vue&type=script&lang=js"
export * from "./brockercharge.vue?vue&type=script&lang=js"
import style0 from "./brockercharge.vue?vue&type=style&index=0&id=20043dcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports